"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const actions_1 = require("../../context/actions");
const store_1 = require("../../context/store");
const ChevronRightSolid_1 = __importDefault(require("../../../IconsNavigation/ChevronRightSolid"));
const InputLabel_1 = __importDefault(require("../InputLabel"));
const styled_1 = require("../../styled");
const styled_2 = require("./styled");
const CryptoList_1 = __importDefault(require("../CryptoList"));
const CryptoInput = () => {
    const { cryptoValue, selectedCrypto } = (0, store_1.useTrackedState)();
    const dispatch = (0, store_1.useDispatch)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [showDrawer, setShowDrawer] = (0, react_1.useState)(false);
    return (react_1.default.createElement(styled_1.Field, null,
        react_1.default.createElement(InputLabel_1.default, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "sell.crypto.title" })),
        react_1.default.createElement(styled_2.SelectWrapper, null,
            react_1.default.createElement(styled_2.StyledInput, { type: "number", value: cryptoValue, placeholder: typeof cryptoValue === "undefined"
                    ? formatMessage({ id: "buy.loading" })
                    : "", onChange: (e) => {
                    const payload = parseFloat(e.target.value);
                    dispatch({
                        type: actions_1.CONTEXT_ACTIONS.SET_CRYPTO_VALUE,
                        payload,
                    });
                } }),
            react_1.default.createElement(styled_2.CurrencyButton, { type: "button", onClick: () => {
                    setShowDrawer(true);
                } },
                react_1.default.createElement("img", { src: selectedCrypto.image, alt: selectedCrypto.code, height: 22, width: 22, loading: "lazy" }),
                react_1.default.createElement(styled_2.CryptoText, null, selectedCrypto.code),
                react_1.default.createElement(ChevronRightSolid_1.default, { size: 10, color: "#0085FF" }))),
        react_1.default.createElement(CryptoList_1.default, { isSell: true, show: showDrawer, setShow: setShowDrawer })));
};
exports.default = CryptoInput;
//# sourceMappingURL=CryptoInput.js.map